import PropTypes from 'prop-types';
import React from 'react';

import { Flex, Box } from 'reflexbox';

import {
  Button,
  Heading,
  Panel,
  PanelHeader,
  Space,
  Text,
} from 'rebass';

const ShadowlandsLaunch = ({ onDismiss }) => (
  <Panel theme="warning" style={{ maxWidth: 450 }}>
    <PanelHeader>
      <Heading level={4}>
        Welcome to Shadowlands!
      </Heading>
      <Space auto />
    </PanelHeader>
    <Box>
      <Heading level={5}>
        A Few Quick Notes!
      </Heading>

      <Text my={2}>
        Expansions are hectic! Stay calm and have fun.
      </Text>
      <Text my={2}>
        Some settings (Top Gear gems/enchants, consumables, etc) have been reset to default values.
      </Text>
      <Text my={2}>
        Raidbots and SimC will be updating pretty often to adjust to hotfixes and add anything missing.
      </Text>
      <Text my={2}>
        For more detailed discussions, check the Raidbots Discord or your own class Discord.
      </Text>
      <Text my={2}>
        <a
          href="https://medium.com/raidbots/raidbots-shadowlands-status-f78f5bbbce4e"
          target="_blank"
          rel="noreferrer noopener"
        >
          More details on the blog
        </a>
      </Text>

      <Flex justify="center" mt={4}>
        <Button theme="success" onClick={onDismiss}>
          Got it
        </Button>
      </Flex>
    </Box>
  </Panel>
);

ShadowlandsLaunch.propTypes = {
  onDismiss: PropTypes.func.isRequired,
};

export default ShadowlandsLaunch;
